import React from 'react';
import Typography from 'fuse-ui/components/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import chartStyles from  '../../../../scss/_variables.scss';
import { calculateLegendCaptionValues, formatBubbleCaption } from './dmarc-chart-helpers';
const styles = theme => ( {
    bubble: {
        '&:nth-child(1)': {
            height: '6px',
            width: '6px',
        },
        '&:nth-child(2)': {
            height: '22px',
            width: '22px',
        },
        '&:nth-child(3)': {
            height: '38px',
            width: '38px',
        },
        '&:nth-child(4)': {
            height: '54px',
            width: '54px',
        },
        '&:nth-child(5)': {
            height: '70px',
            width: '70px',
        },
        'align-self': 'end',
        'background-color': 'rgba(0,0,0,0)',
        border: '1px solid',
        'border-color': theme.palette.text.secondary,
        'border-radius': '50%',
    },
    bubbleWrapper: {
        'column-gap': '24px',
        display: 'grid',
        'grid-template-columns': '6px 22px 38px 54px 70px',
        'row-gap': '4px'
    },
    caption: {
        '&:nth-child(6)': { //Left most bubble caption should be justified left
            'justify-self': 'left'
        },
        'justify-self': 'center',
    },
    colorLabelHigh: {
        display: 'inline-block',
        'padding-left': '12px'
    },
    colorLabelLow: {
        display: 'inline-block',
        'padding-right': '12px'
    },
    colorLines: {
        '& span': {
            '&:nth-child(2)': {
                background: chartStyles.blue900,
            },
            '&:nth-child(3)': {
                background: chartStyles.blue700,
            },
            '&:nth-child(4)': {
                background: chartStyles.blue600,
            },
            '&:nth-child(5)': {
                background: chartStyles.blue400,
            },
            '&:nth-child(6)': {
                background: chartStyles.blue200,
            },
            '&:nth-child(7)': {
                background: chartStyles.orange200,
            },
            '&:nth-child(8)': {
                background: chartStyles.orange300,
            },
            '&:nth-child(9)': {
                background: chartStyles.orange400,
            },
            '&:nth-child(10)': {
                background: chartStyles.orange600,
            },
            '&:nth-child(11)': {
                background: chartStyles.orange800,
            },
            display: 'inline-block',
            height: 8,
            marginLeft: 1,
            width: 'calc(100% / 12 - 2px)',
        },
        width: '100%',
    },
    colorScale: {
        display: 'flex',
        marginBottom: theme.spacing.unit * 2,
        marginTop: theme.spacing.unit,
    },
    colorTitle: {
        '&>p:first-of-type': {
            minWidth: 80,
        },
        display: 'flex',
    },
} );


const legendSpans = ( num ) => {
    const spans = [];
    for( var i = 0; i < num; i++ ){
        spans.push( <span key={`color-span${i}`}></span> );
    }

    return spans;
};
export const DmarcChartLegend = ( { classes, aggDomainsData = [] } ) => {
    const captionValues = calculateLegendCaptionValues( aggDomainsData );
    return (
        <React.Fragment>
            <div className={classes.colorTitle}>
                <Typography variant="overline">Abuse Rate:&nbsp;</Typography>
                <Typography variant="caption" color="textSecondary">Percentage of unauthorized messages among total volume</Typography>
            </div>
            <div className={classes.colorScale} data-automation-id="dmarc-color-legend">
                <div className={classes.colorLines}>
                    <Typography className={classes.colorLabelLow}>Low</Typography>
                    { legendSpans( 10 ) }
                    <Typography className={classes.colorLabelHigh}>High</Typography>
                </div>
            </div>
            <Typography variant="overline">Total Volume</Typography>
            <div className={classes.bubbleWrapper}>
                <div className={classes.bubble}></div>
                <div className={classes.bubble}></div>
                <div className={classes.bubble}></div>
                <div className={classes.bubble}></div>
                <div className={classes.bubble}></div>
                <div className={classes.caption}>
                    <Typography color="textSecondary" variant="caption">
                    0
                    </Typography>
                </div>
                <div className={classes.caption}>
                    <Typography color="textSecondary" variant="caption">
                        {formatBubbleCaption( captionValues[0] )}
                    </Typography></div>
                <div className={classes.caption}>
                    <Typography color="textSecondary" variant="caption">
                        {formatBubbleCaption( captionValues[1] )}
                    </Typography></div>
                <div className={classes.caption}>
                    <Typography color="textSecondary" variant="caption">
                        {formatBubbleCaption( captionValues[2] )}
                    </Typography></div>
                <div className={classes.caption}>
                    <Typography color="textSecondary" variant="caption">
                        {formatBubbleCaption( captionValues[3] )}
                    </Typography></div>
            </div>
        </React.Fragment>
    );
};

DmarcChartLegend.propTypes =  {
    aggDomainsData: PropTypes.array.isRequired,
    classes: PropTypes.object,
};

export default withStyles( styles )( DmarcChartLegend );
